module.exports = "<section>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/common/letterTemplates/barcode-not-found/barcode-not-found.html
// module id = 492
// module chunks = 0